const STYLES = {
    ALLOW: "bg-green-50 text-green-700 border-green-200",
    RELEASE: "bg-green-50 text-green-700 border-green-200",
    FREEZE: "bg-amber-50 text-amber-700 border-amber-200",
    REVIEW: "bg-amber-50 text-amber-700 border-amber-200",
    DENY: "bg-red-50 text-red-700 border-red-200",
};

export const OutcomeBadge = ({ outcome, className = "" }) => {
    const style = STYLES[outcome] || "bg-slate-100 text-slate-600 border-slate-200";
    return (
        <span
            data-testid={`outcome-badge-${(outcome || "").toLowerCase()}`}
            className={`inline-flex items-center rounded-sm border px-2 py-0.5 text-xs font-mono uppercase tracking-wide ${style} ${className}`}
        >
            {outcome}
        </span>
    );
};
